import { CommentsList } from "@bolt/comments";
import React from "react";
import { EntityTypes } from "../../constants/entityTypes";

export interface CommentPermissions {
  canComment?: boolean;
  canEdit?: boolean;
  canPin?: boolean;
  canDelete?: boolean;
}

export interface TaskExecutionActivityFeedProps {
  taskId?: string;
  apiBaseUrl?: string;
  getAuthRequestHeader?: () => Promise<Record<string, string> | undefined>;
  commentPermissions?: CommentPermissions;
}
export const TaskExecutionActivityFeed: React.FC<
  TaskExecutionActivityFeedProps
> = (props) => {
  if (!props.taskId) {
    return null;
  }

  return (
    <section className="bolt-task-execution-activity-feed">
      <CommentsList
        entityType={EntityTypes.Task.EntityType}
        entityId={props.taskId}
        canComment={props.commentPermissions?.canComment}
        canEdit={props.commentPermissions?.canEdit}
        canPin={props.commentPermissions?.canPin}
        canDelete={props.commentPermissions?.canDelete}
        apiBaseUrl={props.apiBaseUrl || ""}
        getAuthRequestHeader={props.getAuthRequestHeader || (() => Promise.resolve({}))}
        showHeader={false}
      />
    </section>
  );
};
